export const environment = {
    production: true,
    version: window['env']['VERSION'],
    url: window['env']['URL'],
    assetPath: './assets',
    cdn: {
        asset: window['env']['CDN_URL']
    },
    api: {
        url: window['env']['API_URL']
    },
    id: {
        url: window['env']['ID_URL'],
        realm: window['env']['ID_REALM'],
        clientId: window['env']['ID_CLIENT_ID'],
    },
    analytics: {
        url: window['env']['ANALYTICS_URL'],
    }
};